import { memo, useEffect, useState } from "react";

import { CustomInput } from "../../../../../components/CustomInput/CustomInput";
import { useDisableSubmit } from "../../../../../hooks/useDisableSubmit";
import type { IEditUser } from "../../MembersTable/MembersTable";

interface IProps {
  setInvitationData: (value: any) => void;
  setErrorState: (value: boolean) => void;
  validationErrors: any | null;
}

const defaultValues = {
  firstName: "",
  lastName: "",
  email: "",
};

const InviteSingleMember: React.FC<IProps> = memo(
  ({ setErrorState, setInvitationData, validationErrors }) => {
    const [formValues, setFormValues] =
      useState<Partial<IEditUser>>(defaultValues);

    const { isDisabled, setInitialValue, onUpdateValues } = useDisableSubmit(1);
    useEffect(() => {
      setFormValues(defaultValues);
      setInitialValue(defaultValues);
    }, [setFormValues, setInitialValue]);

    useEffect(() => {
      setErrorState(isDisabled);
    }, [isDisabled, setErrorState]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      if (formValues) {
        onUpdateValues({
          ...formValues,
          [name]: value,
        });
        setFormValues({
          ...formValues,
          [name]: value,
        });
      }
    };

    useEffect(() => {
      setInvitationData(formValues);
    }, [formValues, setInvitationData]);
    return (
      <div>
        <CustomInput
          label="First name"
          handleChange={handleChange}
          inputValue={formValues?.firstName || ""}
          placeholder="John"
          name="firstName"
          autoFocus
          errorMessage={{ error: validationErrors?.firstName }}
          maxLength={150}
        />
        <CustomInput
          label="Last name"
          handleChange={handleChange}
          inputValue={formValues?.lastName || ""}
          placeholder="Doe"
          name="lastName"
          errorMessage={{ error: validationErrors?.lastName }}
          maxLength={150}
        />
        <CustomInput
          label="Email"
          handleChange={handleChange}
          inputValue={formValues?.email || ""}
          placeholder="john.doe@acme.com"
          name="email"
          errorMessage={{ error: validationErrors?.email }}
          maxLength={150}
        />
      </div>
    );
  },
);

export { InviteSingleMember };
